import {seoTitle,seoDescription} from "./on-page-seo.mjs";
import {publicJsonLdGraph} from "./public-jsonld.mjs";
export function publicPageHeadModel(meta,{canonical=meta.canonical,language}={}) {
  const title=seoTitle(meta.title||"");
  const description=seoDescription(meta.description||"",title);
  return {...meta,title,description,canonical,
    jsonLd:publicJsonLdGraph(meta.jsonLd,{canonical,title,description,language})};
}
const attribute=value=>String(value??"").replace(/[&<>"']/g,char=>
  ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"})[char]);
export function renderPublicPageHead(meta,{prerender=false}={}) {
  const model=publicPageHeadModel(meta);
  if(!model.canonical)throw Error("Public head requires a resolved canonical");
  const json=model.jsonLd&&JSON.stringify(model.jsonLd).replace(/[<>&\u2028\u2029]/g,
    char=>`\\u${char.charCodeAt(0).toString(16).padStart(4,"0")}`);
  return `<meta name="description" content="${attribute(model.description)}">`+
    `<meta property="og:title" content="${attribute(model.title)}">`+
    `<meta property="og:description" content="${attribute(model.description)}">`+
    `<meta property="og:url" content="${attribute(model.canonical)}">`+
    `<link rel="canonical" href="${attribute(model.canonical)}">`+
    (model.ogImage?`<meta property="og:image" content="${attribute(model.ogImage)}">`:"")+
    (json?`<script type="application/ld+json" ${prerender?'data-prerender="true"':"data-page"}>${json}</script>`:"");
}
